
import XDialog from 'vux/src/components/x-dialog/index.vue'

export default {
name: "myImage",
components: {
XDialog,
},
props: {
imageUrl: String,
},
data() {
return {
activeUrl: this.imageUrl,
showHideOnBlur: true,
};
},
mounted() {},
beforeDestroy() {},
methods: {
onHide() {
console.log("隐藏视频窗口");
this.$emit("onHideMyImage");
},
},
watch: {
imageUrl(url) {
this.activeUrl = url;
},
},
};



// WEBPACK FOOTER //
// ./src/myComponents/myImage/myImage.vue